/**
 * Clio sign-in in "manage" mode: the user authorizes at app.clio.com with a Clio Manage developer app.
 * Both values are public identifiers (the App Key is visible in the authorize URL); the App Secret never reaches the browser,
 * it lives in Secret Manager and is used by the function `clioSsoManageV1`.
 * The redirect URIs registered on that Clio app must include environment.config.clio.SSO.callback of every environment.
 */
export const CLIO_MANAGE_SSO = {
  key: 'wjniln3xg2yQh0Ywlf9HzSXjBNAUls7nVlCD03K0',
  authURL: 'https://app.clio.com/oauth/authorize',
  /** Firebase callable that exchanges the code and returns a custom token. */
  functionName: 'clioSsoManageV1',
};
